var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4167 7.09375V4.73422L13.8659 5.3576C14.8196 5.76788 15.925 5.32733 16.3352 4.3738C16.7454 3.42026 16.3049 2.31469 15.3514 1.90449L11.291 0.157799C11.0876 0.0686356 10.8656 0.0140558 10.6321 0.00241397C10.5689 -0.000804658 10.5056 -0.000804658 10.4423 0.00241397C10.2089 0.0140558 9.98687 0.0685672 9.78348 0.15773L5.723 1.90449C4.76947 2.31469 4.32899 3.42026 4.7392 4.3738C5.04531 5.08532 5.73834 5.51107 6.46665 5.51107C6.71441 5.51107 6.96642 5.46176 7.20851 5.3576L8.65764 4.73422V7.09375C3.74108 7.98264 0 12.294 0 17.4628C0 23.273 4.72694 28 10.5372 28C16.3474 28 21.0744 23.2731 21.0744 17.4628C21.0744 12.294 17.3334 7.98264 12.4167 7.09375ZM10.5372 24.2408C6.79974 24.2408 3.75916 21.2002 3.75916 17.4628C3.75916 13.7254 6.79981 10.6848 10.5372 10.6848C14.2746 10.6848 17.3153 13.7254 17.3153 17.4628C17.3153 21.2002 14.2746 24.2408 10.5372 24.2408Z",
    fill: "url(#paint0_linear_968_267)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5947 4.3738C13.4822 4.6354 13.317 4.85817 13.1173 5.03553L13.866 5.3576C14.8197 5.76788 15.9252 5.32733 16.3353 4.3738C16.7455 3.42026 16.305 2.31469 15.3515 1.90449L11.2911 0.157799C11.0876 0.0686356 10.8656 0.0140558 10.6322 0.00241397C10.5689 -0.000804658 10.5056 -0.000804658 10.4424 0.00241397C10.2089 0.0140558 9.98692 0.0685672 9.78353 0.15773L9.16699 0.422959L12.6109 1.90449C13.5644 2.31469 14.0049 3.42026 13.5947 4.3738Z",
    fill: "url(#paint1_linear_968_267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4169 7.09415V4.73462L11.3381 4.30873C10.5404 3.99386 9.67629 4.58177 9.67629 5.4393C9.67629 6.35442 10.2559 7.17482 11.124 7.46443C13.818 8.36318 16.0312 10.3224 17.2663 12.8443C17.0101 13.0222 16.7622 13.2111 16.5232 13.4105C16.4062 13.508 16.2915 13.6082 16.179 13.7106C16.8965 14.7858 17.3154 16.0765 17.3154 17.4632C17.3154 17.7708 17.2944 18.0735 17.2545 18.3703C17.2574 18.3648 17.2603 18.3594 17.2632 18.3539C17.5313 17.8452 18.308 18.076 18.2624 18.6492C18.2554 18.7378 18.2477 18.8155 18.2394 18.8774C17.6067 23.5732 13.8689 27.298 9.16699 27.9113C9.61561 27.9699 10.0729 28.0003 10.5373 28.0003C16.3476 28.0003 21.0745 23.2734 21.0745 17.4631C21.0746 12.2944 17.3336 7.98304 12.4169 7.09415Z",
    fill: "url(#paint2_linear_968_267)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.75918 17.4626C3.75918 14.0152 6.34621 11.1607 9.68085 10.7385C9.40028 10.7029 9.1145 10.6846 8.82442 10.6846C5.08697 10.6846 2.04639 13.7252 2.04639 17.4626C2.04639 21.2 5.08704 24.2406 8.82442 24.2406C9.11444 24.2406 9.40028 24.2223 9.68085 24.1867C6.34621 23.7645 3.75918 20.91 3.75918 17.4626Z",
    fill: "url(#paint3_linear_968_267)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_968_267",
    x1: 0.918817,
    y1: 14,
    x2: 21.2941,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_968_267",
    x1: -1.34992,
    y1: 2.75558,
    x2: 19.1237,
    y2: 2.75558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_968_267",
    x1: -1.34979,
    y1: 16.1115,
    x2: 19.1238,
    y2: 16.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_968_267",
    x1: -4.22618,
    y1: 17.4626,
    x2: 12.2847,
    y2: 17.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.b786d8a83160f6228e6bc3c1f1f838ae.svg";
export { ForwardRef as ReactComponent };